<div mat-flat-button class="formclose" align="right"
	(click)="closeUserForm()">
	<img src="assets/img/icons/forma-11.png">
</div>
<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
	<div class="loginbox">

		<form [formGroup]="User" class="example-form">
			<div *ngIf="!isedit" class="fheader">Add User</div>
			<div *ngIf="isedit" class="fheader">Edit User</div>
			<div class="flabel">Phone</div>

			<mat-form-field appearance="outline" class="example-full-width"
				style="width:100%"> <mat-label>Enter
			your phone number</mat-label> <input (keypress)="numberOnly($event)" matInput formControlName="userName" value="">
			</mat-form-field>
			
			<!-- <p>sdasd {{User.userName.errors.required}}</p>
			<mat-error *ngIf="User.userName.errors.required">Mobile number is required</mat-error> -->
		
			<mat-error *ngIf="validator.UniqueUser">{{validator.errorMessage}}</mat-error>
			

			
			<button *ngIf="!isedit" style="width: 100%;margin-top: 14px;" [disabled]="!User.valid" mat-flat-button
				class="btn" (click)="createUser()">Add</button>
			<button *ngIf="isedit" style="width: 100%;margin-top: 14px;" [disabled]="!User.valid" mat-flat-button
				class="btn" (click)="createUser()">Save</button>
		</form>
	</div>
</div>